// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7f8eeb5c","963":"a03f6028"}[chunkId] + ".chunk.js";
};